// extracted by mini-css-extract-plugin
module.exports = {"rotatingText":"RotatingText_rotatingText__WZ4aM","item":"RotatingText_item___uY2_","rotateText":"RotatingText_rotateText__aCMJQ","paused":"RotatingText_paused__EU17d"};